export const SET_STATE_TOOLTIP = "SET_STATE_TOOLTIP";
export const SET_TOOLTIP = "SET_TOOLTIP";
